import { render, staticRenderFns } from "./Simulator3.vue?vue&type=template&id=3773022e&scoped=true"
import script from "./Simulator3.vue?vue&type=script&lang=js"
export * from "./Simulator3.vue?vue&type=script&lang=js"
import style0 from "./Simulator3.vue?vue&type=style&index=0&id=3773022e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773022e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBottomSheet,VBtn,VCard,VCheckbox,VCol,VCombobox,VContainer,VForm,VIcon,VImg,VRow,VSpacer,VTextField,VToolbar,VToolbarItems,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3773022e')) {
      api.createRecord('3773022e', component.options)
    } else {
      api.reload('3773022e', component.options)
    }
    module.hot.accept("./Simulator3.vue?vue&type=template&id=3773022e&scoped=true", function () {
      api.rerender('3773022e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Simulator3.vue"
export default component.exports